import { useMemo } from 'react'

import { Hash } from 'types/entities'

import { useNativeCurrency } from 'hooks/token'
import { useGetBalancesRequest } from 'hooks/api'

import { useToken } from 'state/airdrop/hooks'

export function useBalances(address?: Hash | null) {
  const token = useToken()
  const nativeCurr = useNativeCurrency()

  const balancesRequest = useGetBalancesRequest()

  const customerBalances = useMemo(() => {
    if (!address) {
      return undefined
    }
    return balancesRequest?.data?.[address]
  }, [balancesRequest?.data, address])

  const nativeBalance = useMemo(() => {
    return customerBalances?.[nativeCurr.address]?.bgBalance || '0'
  }, [customerBalances, nativeCurr.address])

  const nativeBalanceToDisplay = useMemo(() => {
    return customerBalances?.[nativeCurr.address]?.balance || '0'
  }, [customerBalances, nativeCurr.address])

  const tokenBalance = useMemo(() => {
    if (!token?.address) {
      return '0'
    }
    return customerBalances?.[token.address]?.bgBalance || '0'
  }, [token, customerBalances])

  const tokenBalanceToDisplay = useMemo(() => {
    if (!token?.address) {
      return '0'
    }
    return customerBalances?.[token.address]?.balance || '0'
  }, [token, customerBalances])

  return useMemo(
    () => ({
      nativeBalance,
      tokenBalance,
      tokenBalanceToDisplay,
      nativeBalanceToDisplay,
    }),
    [nativeBalance, nativeBalanceToDisplay, tokenBalance, tokenBalanceToDisplay],
  )
}
